import {Link} from "react-router-dom";
import React from "react";
import AddPeopleForm from "../../Form/AddPeopleForm";
import ParticipationsTable from "./ParticipationsTable";
import styles from "../../../pages/Admin/Admin.module.css";
import { ReactComponent as AjouterIcone } from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";

const ParticipationsVue = ({ entreprise, contrat, activite, seance, participations, putActifOpenModal, putShowModalRatingOpenModal, handleSubmitParticipationStatus = null, putParticipationPresenceOpenModal }) => {

    return (
        <>
            <div className={styles.navLink}>
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone/>
                    Ajouter un participant
                </Link>
            </div>

            <ParticipationsTable entreprise={entreprise} contrat={contrat} activite={activite} seance={seance}
                                 participations={participations} putActifOpenModal={putActifOpenModal}
                                 putShowModalRatingOpenModal={putShowModalRatingOpenModal}
                                 handleSubmitParticipationStatus={handleSubmitParticipationStatus} putPresence={putParticipationPresenceOpenModal}/>

            <div style={{ marginTop: "10px" }}>
                {participations.length === 0 && <span>Aucun participant</span>}
            </div>
        </>
    )
}

export default ParticipationsVue;